module.exports = __webpack_public_path__ + "img/41408370476170076.331c19c3.png";